import { ICON_TYPES } from '../constants';

export const ActivitesIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.375 1.75V7.875H1.75V2.625C1.75 2.39294 1.84219 2.17038 2.00628 2.00628C2.17038 1.84219 2.39294 1.75 2.625 1.75H11.375ZM13.125 0H2.625C1.92881 0 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625L0 9.625H13.125V0Z"
        fill="#141414"
      />
      <path
        d="M18.375 1.75C18.6071 1.75 18.8296 1.84219 18.9937 2.00628C19.1578 2.17038 19.25 2.39294 19.25 2.625V7.875H16.625V1.75H18.375ZM18.375 0H14.875V9.625H21V2.625C21 1.92881 20.7234 1.26113 20.2312 0.768845C19.7389 0.276562 19.0712 0 18.375 0Z"
        fill="#141414"
      />
      <path
        d="M4.375 13.125V19.25H2.625C2.39294 19.25 2.17038 19.1578 2.00628 18.9937C1.84219 18.8296 1.75 18.6071 1.75 18.375V13.125H4.375ZM6.125 11.375H0V18.375C0 19.0712 0.276562 19.7389 0.768845 20.2312C1.26113 20.7234 1.92881 21 2.625 21H6.125V11.375Z"
        fill="#141414"
      />
      <path
        d="M19.25 13.125V18.375C19.25 18.6071 19.1578 18.8296 18.9937 18.9937C18.8296 19.1578 18.6071 19.25 18.375 19.25H9.625V13.125H19.25ZM21 11.375H7.875V21H18.375C19.0712 21 19.7389 20.7234 20.2312 20.2312C20.7234 19.7389 21 19.0712 21 18.375V11.375Z"
        fill="#141414"
      />
    </svg>
  );
};

ActivitesIcon.iconType = ICON_TYPES.ACTIVITIES;
